module.exports = "<base-multi-select :options=\"resources\" item-value=\"id\" :return-object=\"false\" :rules=\"rules\" :allow-group=\"true\" :multiple=\"true\"\n  v-model=\"vModel\" :fetch=\"handleFilter\" :disabled=\"disabled\" />";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ticket/components/ticket-mandate-selector/template.html
// module id = BrrD
// module chunks = 0